import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    section: "Orders & Shipping",
    items: [
      { q: "How long does delivery take?", a: "Orders are processed within 24 hours and delivered PAN India in 3-7 business days. Bridal orders may take 7-12 days due to intricate custom packing." },
      { q: "Do you offer free shipping?", a: "Yes! Free shipping across India on orders above ₹999. Below ₹999, a flat ₹79 fee applies." },
      { q: "Is Cash on Delivery available?", a: "COD is available on orders below ₹5000. A small ₹49 handling fee applies for COD." },
      { q: "How do I track my order?", a: "Visit our Track Order page and enter your order number (starts with BJ) along with the email you used on the order. You'll also receive SMS + WhatsApp updates." },
    ]
  },
  {
    section: "Returns & Exchange",
    items: [
      { q: "What is your return policy?", a: "15-day easy returns on unused items with original tags and packaging. Bridal ensembles and customised orders are non-returnable." },
      { q: "How does exchange work?", a: "Request an exchange within 15 days. We'll arrange free pickup, and the new piece ships once we receive the original." },
      { q: "When will I get my refund?", a: "Refunds are processed within 5-7 business days after we receive the returned item, back to your original payment method." },
    ]
  },
  {
    section: "Product & Care",
    items: [
      { q: "Is Bindni jewellery really anti-tarnish?", a: "Yes. Our proprietary micron-gold plating over anti-tarnish brass keeps the shine for years, even with daily wear." },
      { q: "Is it hypoallergenic?", a: "Absolutely. All pieces are nickel-free and safe for sensitive skin." },
      { q: "How do I care for my jewellery?", a: "Store in the provided velvet pouch, wipe gently with a soft cotton cloth, and avoid direct contact with water and sweat." },
      { q: "Do you offer size guides?", a: "Yes — every product page has size details. For rings and bangles, message us on WhatsApp Catalogue (+91 79877 80925) with your regular size for personalised guidance." },
    ]
  },
  {
    section: "Payments & Security",
    items: [
      { q: "What payment methods do you accept?", a: "UPI, all major Credit/Debit cards, Net Banking, Wallets (Paytm, PhonePe, GooglePay), and Cash on Delivery." },
      { q: "Is checkout secure?", a: "Yes. All payments are processed via PCI-DSS compliant gateways with 256-bit SSL encryption." },
      { q: "Do you have a discount code?", a: "Yes — use BINDNI10 at checkout for 10% off on orders above ₹999. It's our only discount code." },
    ]
  },
];

const Item = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-brand-gold/25">
      <button onClick={() => setOpen(!open)} className="w-full py-5 flex items-center justify-between text-left" data-testid={`faq-q-${q.slice(0, 20).replace(/\s+/g, '-')}`}>
        <span className="font-serif-brand text-lg text-brand-charcoal pr-6">{q}</span>
        <ChevronDown size={20} strokeWidth={1.5} className={`text-brand-maroon shrink-0 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <p className="text-brand-muted pb-6 leading-relaxed">{a}</p>}
    </div>
  );
};

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="faq-page">
      <p className="label-tiny text-brand-gold">Help Centre</p>
      <h1 className="font-serif-brand text-4xl lg:text-5xl text-brand-charcoal mt-2">Frequently Asked Questions</h1>
      <p className="text-brand-muted mt-3">Everything you need to know before, during, and after your order.</p>

      <div className="mt-12 space-y-14">
        {FAQS.map((s) => (
          <section key={s.section}>
            <h2 className="font-serif-brand text-2xl text-brand-maroon mb-4">{s.section}</h2>
            {s.items.map((it) => <Item key={it.q} {...it} />)}
          </section>
        ))}
      </div>
    </div>
  );
}
